<template>
  <div id="wrap">
    <div class="dashboard clear">
      <Toolbar isMain="true" :playAlarmError="playAlarmError"></Toolbar>
      <Navigation isMain="true"></Navigation>

      <div class="home">
        <div v-if="csOrAdminOrMonitor" class="category cs">
          <div class="title">CS 관리</div>
          <div class="items">
            <div v-if="csOrAdminOrMonitor" class="item" @click="goPage('IncompletedPay')">
              <div class="title">불완전 결제 조회 및 처리</div>

              <div class="ico">
                <img src="/static/img/ico-incompleted-pay.png" alt />
              </div>

              <div class="content">
                <div>
                  <span class="number">{{ incompletedCount }}</span>
                  개의 처리항목 대기중
                </div>
              </div>
            </div>

            <!--
            <div class="item" @click="goPage('PayHistory')">
              <div class="title">고객 결제 기록 건당 조회</div>

              <div class="ico">
                <img src="/static/img/ico-search-payment-case.png" alt />
              </div>

              <div class="content">
                <div>cs가 필요한 거래기록을 조회합니다</div>
              </div>
            </div>
            -->

            <!--
            <div class="item" @click="goPage('PurchaseHistory')">
              <div class="title">판매 현황 조회</div>

              <div class="ico">
                <img src="/static/img/ico-search-purchase.png" alt />
              </div>

              <div class="content">
                <div>판매된 품목 및 총금액을 조회합니다</div>
              </div>
            </div>
            -->

            <div v-if="csOrAdmin" class="item" @click="goPage('Customer')">
              <div class="title">고객 CS 응대</div>

              <div class="ico">
                <img src="/static/img/ico-search-payment-case.png" alt />
              </div>

              <div class="content">
                <div>고객이 제기한 이의를 처리합니다.</div>
              </div>
            </div>

            <div v-if="csOrAdmin" class="item" @click="goPage('Refund')">
              <div class="title">고객 입금 관리</div>

              <div class="ico">
                <img src="/static/img/ico-search-payment-case.png" alt />
              </div>

              <div class="content">
                <div>고객이 제기한 이의 중에 만료된 건을 처리합니다.</div>
              </div>
            </div>

            <div v-if="csOrAdmin" class="item" @click="goPage('Nonpayment')">
              <div class="title">미결제 손실</div>

              <div class="ico">
                <img src="/static/img/ico-search-payment-case.png" alt />
              </div>

              <div class="content">
                <div>미결제 손실을 처리합니다.</div>
              </div>
            </div>

          </div>
        </div>

        <div class="category-group">
          <div v-if="csOrAdminOrBizAdmin" class="category device">
            <div class="title">냉장고 관리</div>
            <div class="items">
              <div v-if="csOrAdminOrBizAdmin" class="item" @click="goPage('Device')">
                <div class="title">냉장고 관리</div>

                <div class="ico">
                  <img src="/static/img/ico-incompleted-pay.png" alt />
                </div>

                <div class="content">
                  <div>냉장고를 조회합니다</div>
                </div>
              </div>
              <div v-if="csOrAdminOrBizAdmin" class="item" @click="goPage('Product')">
                <div class="title">상품 관리</div>

                <div class="ico">
                  <img src="/static/img/ico-incompleted-pay.png" alt />
                </div>

                <div class="content">
                  <div>냉장고를 조회합니다</div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="csOrAdmin || bizOrAdminOrBizAdmin || deviceOrAdminOrBizAdmin" class="category stock">
            <div class="title">재고 관리</div>
            <div class="items">
              <div class="item" @click="goPage('Order')">
                <div class="title">발주 관리</div>

                <div class="ico">
                  <img src="/static/img/ico-incompleted-pay.png" alt />
                </div>

                <div class="content">
                  <div>발주를 처리합니다</div>
                </div>
              </div>

              <div class="item" @click="goPage('Stock')">
                <div class="title">재고 관리</div>

                <div class="ico">
                  <img src="/static/img/ico-incompleted-pay.png" alt />
                </div>

                <div class="content">
                  <div>재고를 조회합니다</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="category-group">
          <div v-if="csOrAdmin" class="category sale">
            <div class="title">판매 현황</div>
            <div class="item" @click="goPage('PurchaseHistory')">
              <div class="title">판매 현황 조회</div>

              <div class="ico">
                <img src="/static/img/ico-search-purchase.png" alt />
              </div>

              <div class="content">
                <div>판매된 품목 및 총금액을 조회합니다</div>
              </div>
            </div>
          </div>

          <div v-if="csOrAdminOrBizAdmin || bizOrAdminOrBizAdmin" class="category sale">
            <div class="title">매출 분석 관리</div>
            <div class="items">
              <div class="item" @click="goPage('Sale')">
                <div class="title">매출 분석 관리</div>

                <div class="ico">
                  <img src="/static/img/ico-incompleted-pay.png" alt />
                </div>

                <div class="content">
                  <div>매출을 조회합니다</div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="managerOrAdminOrBizAdmin" class="category account">
            <div class="title">계정 및 권한 관리</div>
            <div class="items">
              <div class="item" @click="goPage('Account')">
                <div class="title">계정 관리</div>

                <div class="ico">
                  <img src="/static/img/ico-incompleted-pay.png" alt />
                </div>

                <div class="content">
                  <div>회사, 부서, 사용자를 조회 / 관리합니다</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */

import Configuration from '@/js/Configuration';
import Toolbar from '@/components/include/Toolbar';
import Navigation from '@/components/include/Navigation';

export default {
  components: {
    Toolbar,
    Navigation,
  },
  data: () => ({
    uID: null,
    scope: null,
    role: null,
    incompletedCount: 0,
    interval: null,
    gettingCount: false,
    audio: null,
    playAlarmError: false,
  }),
  computed: {
    csOrAdmin() {
      return (this.scope === 1 || this.scope === 2 || this.role === 1) && this.role !== 4;
    },
    csOrAdminOrMonitor() {
      return (this.scope === 1 || this.scope === 2 || this.role === 1) || (this.scope === 2 && this.role === 4);
    },
    csOrAdminOrBizAdmin() {
      return (this.scope === 1 || this.scope === 2 || this.role === 1 || this.role === 5) && this.role !== 4;
    },
    bizOrAdminOrBizAdmin() {
      return (this.scope === 1 || this.scope === 3 || this.role === 1 || this.role === 5);
    },
    deviceOrAdminOrBizAdmin() {
      return (this.scope === 1 || this.scope === 4 || this.role === 1 || this.role === 5);
    },
    managerOrAdminOrBizAdmin() {
      return (this.role === 1 || this.role === 2 || this.role === 5);
    },
  },
  created() {
    if (!this.$cookie.get('accessToken')) {
      alert('정보를 가져오는데 실패하였습니다.');

      this.$deleteCookie();
      this.$router.push({ name: 'Login' });
      return;
    }

    const token = this.$jwtDecode(this.$cookie.get('accessToken'));
    this.uID = token.uID;
    this.scope = token.scope;
    this.role = token.role;

    //
    this.audio = new Audio('/static/audio/classic-alarm.wav');
    if (this.audio) {
      this.audio.autoplay = false;
      this.audio.id = 'myAudio';
    }

    //
    if (this.csOrAdminOrMonitor) {
      this.getIncompletedCount(false);
      this.interval = setInterval(() => {
        if (!this.gettingCount) {
          this.getIncompletedCount(true);
        }
      }, 5000);
    }
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }

    //
    if (this.audio) {
      this.audio.pause();
      this.audio = null;
    }
  },
  methods: {
    async getIncompletedCount(polling) {
      this.gettingCount = true;

      try {
        const res = await this.$http.get(
          `${Configuration.value(
            'CPAYMENT_ADDRESS',
          )}/api/v1/cpayment/payment/count?state=2&state=3&approveResult=3&polling=${polling}`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (res.status !== 200) {
          throw new Error(`Response status is "${res.status}"`);
        }
        if (res.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${res.data.resultCode}"`);
        }

        this.incompletedCount = res.data.count;
        this.gettingCount = false;
        this.playAlarm();
      } catch (e) {
        this.gettingCount = false;

        if (!polling) {
          alert('정보를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        }
        console.error(e);
      }
    },
    goPage(name) {
      this.$router.push({ name });
    },
    async playAlarm() {
      if (this.incompletedCount > 0 && this.audio) {
        try {
          await this.audio.play();
          this.playAlarmError = false;
        } catch (e) {
          console.error('play error:', e);
          this.playAlarmError = true;
        }
      }
    },
  },
};
</script>

<style scoped>
.home {
  width: 100%;
  /* height: calc(100% - 80px);*/
  height: 100%;
  background-color: #ebf0f3;
  padding-top: 50px;
}
.home .category-group {
  display: flex;
}
.home .category {
  padding-top: 30px;
}
.home .category .title {
  font-weight: 700;
  font-size: 18px;
}
.category .items {
  display: flex;
}
.category .item {
  margin-top: 24px;
  margin-right: 24px;
  width: 224px;
  height: 208px;
  padding: 0 20px;
  border-radius: 2px;
  border: solid 0.5px #586063;
  background-color: #fafcfe;
  cursor: pointer;
  transition: 0.2s;
}
.category .item:hover {
  background-color: #f0f0f0;
}
.category .item .title {
  height: 64px;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 64px;
  letter-spacing: normal;
  color: #192124;
}
.category .item .ico {
  width: 100%;
  height: 80px;
  text-align: center;
}
.category .item .ico img {
  width: 80px;
  height: 80px;
  text-align: center;
}
.category .item .content {
  display: flex;
  margin-bottom: 16px;
  height: 46px;
  align-items: flex-end;
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: -0.19px;
  color: #9d9ea1;
}
.category .item .content .number {
  font-size: 32px;
  font-weight: bold;
  letter-spacing: -0.6px;
  color: #212121;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue